import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { BaseUrl } from '../../helper/BaseUrl';
import { getMediaUrl } from '../../helper/mediaUrl';

export default function OfferListing({ initialData }) {
  const [visibleCount, setVisibleCount] = useState(4);
  const [allData, setAllData] = useState(() => Array.isArray(initialData) ? initialData : []);

  // API Calling
  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/offers`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.offers === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.offers);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  useEffect(() => {
    fetcher();
  }, [])



  //---- lazy load
  useEffect(() => {
    setVisibleCount(4);
  }, [allData]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 300
      ) {
        setVisibleCount((prev) => prev + 4);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  if (!allData) {
    return <div style={{ height: "100vh", width: "100%" }}></div>;
  }


  return (
    <>
      <section className="image-subhead offerpage-banner">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-lg-3 col-md-3">
              <ul>
                <li><Link to={"/"}>Home</Link></li>
                <li>Offer Listing</li>
              </ul>
            </div>
            <div className="col-lg-6 col-md-6">
              <p>Exclusive Deals & Packages, Extraordinary Stays.</p>
              <h1 className='heading'>The Holiday You Deserve is Just a Click Away</h1>
            </div>
          </div>
        </div>
        <img src="/image/offerlist-banner.webp" className='img-responsive' alt="banner" />
      </section>

      <section className="offer-listing">
        <div className="container">
          <div className="row">
            {allData?.slice(0, visibleCount)?.map((item, index) => (
              <div className="col-lg-6 col-md-6" key={index}>
                <Link to={`/offer-listing/${item?.slug}`} className="offer-card">
                  <img src={getMediaUrl(item?.thumbnail_image)} className="img-responsive" alt={item?.thumbnail_image_alt} loading="lazy" />
                  {item?.time_left && (<span className="offer-badge">{item.time_left}</span>)}
                  <div className="offercard-content">
                    <div>
                      <h4>{item?.title}</h4>
                      <p>{item?.minimum_stay}</p>
                    </div>
                    <span><img src="/image/right-arrow.svg" alt="arrow" loading="lazy" /></span>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
